import { useMemo, useState, type ReactNode } from "react";
import { useLocation } from "react-router";

import { NavigationOverlayContext } from "./NavigationOverlayContext.shared";

export const NavigationOverlayProvider = ({
  businessId,
  children,
}: {
  businessId: number | undefined;
  children: ReactNode;
}) => {
  const location = useLocation();
  const scope = `${businessId}:${location.key}`;
  const [state, setState] = useState<{
    scope: string;
    activeOverlay: string | null;
  }>({
    scope,
    activeOverlay: null,
  });

  if (state.scope !== scope) {
    setState({ scope, activeOverlay: null });
  }

  const value = useMemo(
    () => ({
      activeOverlay: state.scope === scope ? state.activeOverlay : null,
      openOverlay: (id: string) => setState({ scope, activeOverlay: id }),
      closeOverlay: (id?: string) =>
        setState((current) => {
          // An old panel's focus-out callback must not dismiss its replacement.
          if (
            current.scope !== scope ||
            (id !== undefined && current.activeOverlay !== id)
          ) {
            return current;
          }
          return { scope, activeOverlay: null };
        }),
    }),
    [scope, state],
  );

  return (
    <NavigationOverlayContext.Provider value={value}>
      {children}
    </NavigationOverlayContext.Provider>
  );
};
